$(document).ready ->  
  $('.file-category-sortable').sortable({
    cursor: 'move'
  })